import { Component, Input } from '@angular/core';

@Component({
  selector: 'pcs-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  @Input() fullScreen: false;

  get containerClasses() {
    return this.fullScreen ? 'container-fluid full-screen' : 'container';
  }

}
